import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';

export const sansSerif = `"游ゴシック体", "Yu Gothic", YuGothic, sans-serif`;
export const serif = `"游明朝体", "Yu Mincho", YuMincho, "Sawarabi Mincho", serif`;

const FontStyles = {
  text1: css`
    font-family: ${sansSerif};
    font-weight: bold;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 40px;
      line-height: 52px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 32px;
      line-height: 44px;
    `}
  `,
  text2: css`
    font-family: ${sansSerif};
    font-weight: bold;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 28px;
      line-height: 42px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 20px;
      line-height: 32px;
    `}
  `,
  text3: css`
    font-family: ${sansSerif};
    font-weight: bold;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 24px;
      line-height: 36px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 18px;
      line-height: 28px;
    `}
  `,
  text4: css`
    font-family: ${sansSerif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 24px;
      line-height: 36px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 18px;
      line-height: 28px;
    `}
  `,
  text5: css`
    font-family: ${sansSerif};
    font-weight: bold;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 20px;
      line-height: 30px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 16px;
      line-height: 24px;
    `}
  `,
  text6: css`
    font-family: ${sansSerif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 20px;
      line-height: 30px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 16px;
      line-height: 24px;
    `}
  `,
  text7: css`
    font-family: ${sansSerif};
    font-weight: bold;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 16px;
      line-height: 26px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 14px;
      line-height: 22px;
    `}
  `,
  text8: css`
    font-family: ${sansSerif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 16px;
      line-height: 26px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 14px;
      line-height: 22px;
    `}
  `,
  text9: css`
    font-family: ${sansSerif};
    font-weight: bold;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 14px;
      line-height: 24px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 12px;
      line-height: 20px;
    `}
  `,
  text10: css`
    font-family: ${sansSerif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 14px;
      line-height: 24px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 12px;
      line-height: 20px;
    `}
  `,
  text11: css`
    font-family: ${sansSerif};
    font-weight: bold;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 12px;
      line-height: 18px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 11px;
      line-height: 16px;
    `}
  `,
  text12: css`
    font-family: ${sansSerif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 12px;
      line-height: 18px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 11px;
      line-height: 16px;
    `}
  `,
  text13: css`
    font-family: ${serif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 32px;
      line-height: 48px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 22px;
      line-height: 34px;
    `}
  `,
  text14: css`
    font-family: ${serif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 24px;
      line-height: 30px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 18px;
      line-height: 30px;
    `}
  `,
  textSerifSmall: css`
    font-family: ${serif};
    font-weight: normal;

    ${CustomMedia.greaterThan('umedium')`
      font-size: 14px;
      line-height: 24px;
    `}

    ${CustomMedia.lessThan('medium')`
      font-size: 12px;
      line-height: 20px;
    `}
  `
};

export default FontStyles;



// WEBPACK FOOTER //
// ./src/constants/font-styles.js